import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import RouteSelect from '../../../common/forms/select/RouteSelect';
import Select from '../../../common/forms/select/Select';
import { clearRoutes, getRoutes } from '../../../../actions';

export const CircuitForm = ({
  handleSubmit,
  loading,
  loadingRoutes,
  dispatchGetRoutes,
  dispatchClearRoutes,
  options,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearRoutes();
    },
    [],
  );

  const [showOnlyNorthChico, setShowOnlyNorthChico] = useState(false);

  if (loading) return <Loader />;

  const onChange = ({ target: { checked } }) => {
    setShowOnlyNorthChico(checked);
    if (checked) {
      dispatchGetRoutes({ query: ['isNorthChico:true', 'active:true'] });
    } else {
      dispatchClearRoutes();
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre: " required>
          <Field
            name="name"
            component={TextInput}
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción: " required>
          <Field
            name="description"
            component={TextInput}
            placeholder="Descripción"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Norte Chico" required>
          <Field
            name="northChico"
            component="input"
            type="checkbox"
            placeholder="Norte Chico"
            onChange={onChange}
          />{' '}
          <Label>Mostrar Solo Norte Chico</Label>
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Rutas: " required>
          <Field
            name="circuitRouteList"
            component={showOnlyNorthChico ? Select : RouteSelect}
            options={showOnlyNorthChico ? options : []}
            isMulti
            isLoading={loadingRoutes}
            validate={[isRequired]}
            allowRepeatedOptions
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

CircuitForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetRoutes: PropTypes.func.isRequired,
  dispatchClearRoutes: PropTypes.func.isRequired,
  loadingRoutes: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
};

CircuitForm.defaultProps = {
  options: [],
};

const mapStateToProps = ({ RouteUnit }) => ({
  loading: !RouteUnit.Circuit.getIn(['current', 'activity']).isEmpty(),
  loadingRoutes: RouteUnit.Route.getIn(['all', 'loading']),
  options: RouteUnit.Route.getIn(['all', 'content', 'content']).map(
    ({
      id,
      name,
      routeSegmentList,
      sourceLocation,
      destinationLocation,
      intern,
      active
    }) => ({
      value: id,
      label: `${id} - ${name}`,
      routeSegmentList,
      sourceLocation,
      destinationLocation,
      intern,
      active
    }),
  ),
});

const formComponent = reduxForm({
  form: 'CircuitForm',
})(CircuitForm);

const mapDispatchToProps = {
  dispatchGetRoutes: getRoutes,
  dispatchClearRoutes: clearRoutes,
};

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
